module.exports = __webpack_public_path__ + "static/media/rp03.65e00bd4.webp";